import { useEffect } from 'react';
import { useCheckoutGet } from 'app/pages/frames/hooks/checkout';
import { useParams } from 'react-router-dom';

const useApp = () => {
  const { checkoutRequestId } = useParams();
  const { doGet } = useCheckoutGet();

  useEffect(() => {
    if (checkoutRequestId) {
      doGet(checkoutRequestId);
    }
  }, [checkoutRequestId]);
};

export default useApp;
